// extracted by mini-css-extract-plugin
var _1 = "C1Lxv";
var _2 = "s_WZg";
var _3 = "cUeuP";
var _4 = "SJ5Lp";
var _5 = "K5APl";
var _6 = "ER5PD";
var _7 = "L3efs";
var _8 = "yRoR8";
export { _1 as "base", _2 as "inspector", _3 as "main", _4 as "nav", _5 as "sidebar", _6 as "sidebarFilters", _7 as "specifics", _8 as "subnav" }
